export default __webpack_public_path__ + "static/media/2-2.393f2c02.jpg";